import { getRuntimeEnv } from './runtime-env';

const runtime = getRuntimeEnv();

export const environment = {
  production: false,
  API_URL: runtime.API_URL || '/api',
  WEB_URL: runtime.WEB_URL || 'https://dev.lasoberaniadeseguro.com',
  environmentName: 'DEV',
};
